
import { Box, useTheme, useMediaQuery } from "@mui/material"

import { Typography } from "@initia-digital/component-library"

export const SectionHeader = ({ label }: { label: string }) => {
    // -------------------------------

    const theme = useTheme();
    const isSmallerThanSm = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            flex={1}
            my={isSmallerThanSm ? "10px" : "15px"}
            display={isSmallerThanSm ? "flex" : undefined}
            flexDirection={isSmallerThanSm ? "row" : undefined}
            alignItems={isSmallerThanSm ? "center" : undefined}
            justifyContent={isSmallerThanSm ? "center" : undefined}
        >
            <Typography
                variant="body1" fontSize={ isSmallerThanSm ? "1.2rem" : "1.4rem"}
                color={theme.palette.secondary.main} fontWeight={700}
            >                                     
                {label}
            </Typography>
        </Box>
    )
}